import { CalculationSettingsModel, ProcedureSettingsModel, RNAVModel } from './configuration';
import { HorizonRecord } from './HorizonRecord';
import { NavaidDTOCalculation } from './navaid';
import { ProcedureDTOCalculation, ProcedureModel } from './procedure';

export class PerformanceAnalysisDTO {
  navaids: NavaidDTOCalculation[] = [];
  procedure : ProcedureDTOCalculation;
  procedureModel : ProcedureModel;
  procedureFeatureJson: string;
  performanceType : number;
  resultanalysis : string;
  receiverDelay : boolean;
  aircraftSpeed : number;
  runwayUpdateValue : number;
  inertialDrift : number;
  maxAllowedNSE : number;
  isInertialDrift : boolean;
  referenceairportLatitude : number;
  referenceairportLongitude: number;
  name : string;
  calculationSettings: CalculationSettingsModel;
  procedureSettings: ProcedureSettingsModel;
  rnav: RNAVModel;
  horizonOptions : HorizonRecord;
  projectId: number;
}

export class PerformanceAnalysisDTOModal {
  calculationName:string;
  aircraftspeed : number;
  processingtype : string;
  resultanalysis : string;
  isInertial : boolean;
  maxAllowedNSE : number;
  inertialDrift : number;
  runwayUpdateError : number;
  receiverDelay: boolean;
  isReceiverDelayEnable: boolean;

  constructor(){
    this.processingtype = '1';
    this.resultanalysis = "bar";
    this.aircraftspeed = 200;
    this.receiverDelay = true;
    this.maxAllowedNSE = 0.866;
    this.inertialDrift = 8.0;
    this.runwayUpdateError = 0.17;
  }
}
